import React, { useContext } from 'react';

import { useSpeakerAssociations } from '../../../../apis/useSpeakerAssociations';
import Bookmark from '../../../../aurr/components/bookmark/Bookmark';
import MarketingParametersContext from '../../../../aurr/contexts/MarketingParametersContext';
import { WithUserApi } from '../../../../common/interface';
import UserNamesList from '../../../../components/container/user-names-list';
import Card from '../../../../components/presentational/card';
import { CardProps } from '../../../../components/presentational/card/Card';
import { generateClassEyebrow } from '../../../search/utils';
import { ClassResponse } from '../../type';
import { generateClassPathname } from '../../utils';

type ArticleCardProps = WithUserApi &
  Partial<CardProps> & {
    classData: ClassResponse;
    language?: string;
  };

export function RelatedClassCard({
  classData,
  userContentURL,
  userProfileURL,
  width,
  language,
  header,
}: ArticleCardProps) {
  const marketingParameters = useContext(MarketingParametersContext);

  const sysId = classData?.sys?.id || '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { title, slug } = classData.fields;
  const overviewImage = classData.fields.overviewImage?.fields.file.url;

  const { data: classSpeakers } = useSpeakerAssociations({
    contentId: sysId,
    baseURL: userContentURL,
  });

  const bookmark = (
    <Bookmark contentID={sysId} contentTitle={title} variant="icon" />
  );

  return (
    <Card
      key={sysId}
      innerPadding={false}
      header={header ?? generateClassEyebrow(classData)}
      url={marketingParameters.appendToUrl(
        generateClassPathname(slug, language)
      )}
      title={title}
      width={width}
      bookmark={bookmark}
      footer={
        <UserNamesList
          oxygenIds={classSpeakers}
          userContentURL={userContentURL}
          userProfileURL={userProfileURL}
        />
      }
      image={overviewImage}
      cardId={sysId}
      withFallbackImage
    />
  );
}
